export default () =>
  new Date().toLocaleTimeString(document.documentElement.lang, { timeStyle: 'short' });
